var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { CardStatus, ListCardsRequest, Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
let DebitCardStatusHandler = (_dec = service('bb-debit/card-management-service'), _class = class DebitCardStatusHandler extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "cardManagementService", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _defineProperty(this, "TRACKABLE_STATUSES", [CardStatus.CARD_STATUS_ISSUED, CardStatus.CARD_STATUS_ORDERED, CardStatus.CARD_STATUS_ACTIVATABLE]);
  }
  /**
   * Filters out cards that do not have the relationship `RELATIONSHIP_ACCOUNT_HOLDER`.
   */
  _filterAccountOwnerCards(cards) {
    return cards.filter(card => card.relationship.includes(Relationship.RELATIONSHIP_ACCOUNT_HOLDER));
  }

  /**
   * Gets the first trackable card for the given balance ID.
   * Returns the card if found, undefined otherwise.
   */
  async getTrackableCard(balanceId) {
    const response = await this.cardManagementService.client.listCards(ListCardsRequest.create({
      balanceId,
      relationship: Relationship.RELATIONSHIP_CARDHOLDER,
      fieldMask: {
        paths: ['id', 'status', 'balance_id', 'card_brand', 'fulfillment', 'last_four', 'relationship']
      }
    }));
    if (!response.cards || response.cards.length === 0) {
      return undefined;
    }
    const cards = this._filterAccountOwnerCards(response.cards);
    if (cards.length === 0) {
      return undefined;
    }
    const firstCard = cards[0];
    return this.TRACKABLE_STATUSES.includes(firstCard.status) ? firstCard : undefined;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DebitCardStatusHandler as default };
const SERVICE_REGISTRY_KEY = 'debit-card-status-handler';